import { RegistrationStatus } from '@exam-center/graphql';
import { Box, Flex, ReadonlyField, Text } from '@shared/components';

import { CircleIndicatorLabel } from '../circle-indicator-label';
import { registrationStatusLabel } from '../registration-status-selection';
import { getColorAndLabelByStatus } from '../registration-status-selection/registration-status-selection';

interface ExamEventStatusReadonlyFieldProps {
  slotProps?: {
    status?: {
      status: RegistrationStatus;
      reason: string;
    };
  };
}

export default function ExamEventStatusReadonlyField(
  props: Readonly<ExamEventStatusReadonlyFieldProps>,
) {
  const { slotProps } = props;
  return (
    <Flex sx={{ gap: (theme) => theme.spacing(6) }}>
      <Box sx={{ width: '240px' }}>
        <Text variant='body1Semibold'>สถานะการรับสมัคร</Text>
      </Box>
      <Flex
        sx={{
          gap: (theme) => theme.spacing(4),
          minWidth: '400px',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ width: '240px' }}>
          <ReadonlyField
            label='จัดการสถานะ'
            content={
              slotProps?.status ? (
                <CircleIndicatorLabel
                  {...getColorAndLabelByStatus(
                    slotProps?.status.status,
                    registrationStatusLabel[slotProps?.status.status],
                  )}
                />
              ) : (
                <Text variant='body2'>N/A</Text>
              )
            }
          />
        </Box>
        {slotProps?.status?.status === RegistrationStatus.Canceled ? (
          <Box sx={{ width: '400px' }}>
            <ReadonlyField label='สาเหตุที่ยกเลิก' content={slotProps?.status?.reason ?? '-'} />
          </Box>
        ) : null}
        {slotProps?.status?.status === RegistrationStatus.TemporarilyClosed ? (
          <Box sx={{ width: '400px' }}>
            <ReadonlyField
              label='สาเหตุที่ปิดรับสมัครชั่วคราว'
              content={slotProps?.status?.reason ?? '-'}
            />
          </Box>
        ) : null}
      </Flex>
    </Flex>
  );
}
